import { render, staticRenderFns } from "./Giftcard.vue?vue&type=template&id=368e15a0&scoped=true&"
import script from "./Giftcard.vue?vue&type=script&lang=js&"
export * from "./Giftcard.vue?vue&type=script&lang=js&"
import style0 from "./Giftcard.vue?vue&type=style&index=0&id=368e15a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368e15a0",
  null
  
)

export default component.exports